import { takeLatest, put, call, select } from "redux-saga/effects";
import {
  GET_PRICING,
  GET_HARMONY_FULFILLMENT,
  PARSE_HARMONY_GALLERY,
  THD_PRODUCT_DETAILS_UPDATED,
  UPDATE_GCC_PRODUCT_DETAILS_SUCCESS,
} from "../../actions/actionTypes";
import safeSaga from "../safeSaga";
import titleParser from "../../utils/seo/titleParser";
import {
  configuratorSelector,
  pageMetaOverviewSelector,
  productInfoSelector,
} from "../../selectors";
import getPricing from "../pricingSaga/getPricing";
import getPageMetaOverview from '../../actions/pageMetaOverviewActions';
import { updateDynamicTabTitle } from '../../actions/updateDynamicTabTitle';

function* mapskus(productInfo) {
  let items = [];
  let keys = Object.keys(productInfo);
  let excludeItemKeys = ["DefaultProduct"];
  keys = keys.filter((item) => !excludeItemKeys.includes(item));
  keys.forEach((key) => {
    items.push({
      itemId: productInfo[key].itemId,
      isAnchor: ["base","primary"].includes(key) ? true : false,
    });
  });
  return items;
};

function* harmonyData(action) {
  switch (action.type) {

    case "GCC_CONFIGURATOR/LOAD_OPTIONS_SUCCESS": {
      const pageMetaOverview = yield select(pageMetaOverviewSelector);
      const { pageMeta } = pageMetaOverview;
      if (!pageMeta) {
        yield put(getPageMetaOverview());
      }
      break;
    }
    case "GCC_CONFIGURATOR/CHOICE_CHANGED_SUCCESS": {
      const configurator = yield select(configuratorSelector);
      const pageMetaOverview = yield select(pageMetaOverviewSelector);
      const { options, choices } = configurator;
      const { pageMeta } = pageMetaOverview;
      if (!pageMeta) {
        break;
      }

      const harmonyTitle = titleParser(pageMeta.DynamicPageTitle, options, choices);
      const dynamicTabTitle = titleParser(pageMeta.DynamicTabTitle, options, choices);
      yield put(updateDynamicTabTitle(dynamicTabTitle || harmonyTitle));
      const product = {
        configuredProductLabel: harmonyTitle,
      };
      yield LIFE_CYCLE_EVENT_BUS.trigger("configurator.configurator_choice_selected_event", product);
      break;
    }
    case PARSE_HARMONY_GALLERY: {
      const { harmonyGallery } = action;
      if (!harmonyGallery) {
        break;
      }
      const configurator = yield select(configuratorSelector);
      const pageMetaOverview = yield select(pageMetaOverviewSelector);
      const { options, choices } = configurator;
      const { pageMeta } = pageMetaOverview;
      const harmonyTitle = titleParser(pageMeta?.DynamicPageTitle, options, choices);

      const extMedia = {
        configuredProductLabel: harmonyTitle,
        externalMedia: [
          ...harmonyGallery
        ]
      };
      const product = {
        configuredProductLabel: harmonyTitle,
        configuredAssetUrl: harmonyGallery[0].thumbnail,
      };

      yield LIFE_CYCLE_EVENT_BUS.trigger("configurator.configurator_media_gallery_event", extMedia);
      yield LIFE_CYCLE_EVENT_BUS.trigger("configurator.configurator_sticky_nav_event", product);
      break;
    }
    case THD_PRODUCT_DETAILS_UPDATED: {
      const productInfo = yield select(productInfoSelector);
      const items = yield call(mapskus, productInfo);
      if (items.length > 0) {
        LIFE_CYCLE_EVENT_BUS.trigger("configurator.configurator_available_items", { items });
      }
    }
    default:
  }
}

const safeGetPricing = safeSaga(getPricing);

export default function* harmonySaga() {
  yield takeLatest(
    [
      "GCC_CONFIGURATOR/LOAD_OPTIONS_SUCCESS",
      "GCC_CONFIGURATOR/CHOICE_CHANGED_SUCCESS",
      "GCC_CONFIGURATOR/EXECUTE_RULES_SUCCESS",
      PARSE_HARMONY_GALLERY,
      GET_HARMONY_FULFILLMENT,
      THD_PRODUCT_DETAILS_UPDATED
    ],
    safeSaga(harmonyData)
  );
  yield takeLatest(
    [
      GET_PRICING,
      UPDATE_GCC_PRODUCT_DETAILS_SUCCESS,
    ],
    safeGetPricing
  );
}
